/* Kairii — notify capture (back-in-stock + pre-order alerts).
   One module for every [data-kr-notify] button: sold-out card, sold-out PDP, pre-order TBA,
   and "alert me if it slips". Config (public key, customer email, i18n) is injected by
   snippets/kairii-notify.liquid as #kr-notify-data.

   Gating: with no public key set (Theme settings → Kairii Reference → "Notify app public key")
   the buttons fall back to the existing visual "on the list" state — nothing is sent, nothing
   is silently lost. Paste the app key and the same buttons go live through krNotifyAdapter. */
(function () {
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('kr-notify-data').textContent); } catch (e) {}
  var KEY = cfg.key || '';
  var EMAIL = cfg.customerEmail || '';
  var I = cfg.i18n || {};

  // Shopify's |t filter HTML-escapes (e.g. ' -> &#39;, & -> &amp;). These strings are written
  // into textContent, which does NOT decode entities, so decode them once here.
  (function () {
    var ta = document.createElement('textarea');
    function dec(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; ta.innerHTML = s; return ta.value; }
    Object.keys(I).forEach(function (k) { I[k] = dec(I[k]); });
  })();

  var modal = document.querySelector('[data-kr-notify-modal]');
  var scrim = document.querySelector('[data-kr-notify-scrim]');
  var titleEl = modal && modal.querySelector('[data-kr-notify-title]');
  var subEl = modal && modal.querySelector('[data-kr-notify-sub]');
  var formEl = modal && modal.querySelector('[data-kr-notify-form]');
  var emailEl = modal && modal.querySelector('[data-kr-notify-email]');
  var msgEl = modal && modal.querySelector('[data-kr-notify-msg]');
  var submitEl = modal && modal.querySelector('[data-kr-notify-submit]');

  var pendingBtn = null;
  var pendingCtx = null;

  function titleFor(kind) {
    if (kind === 'preorder') return I.titlePreorder;
    if (kind === 'preorder_slip') return I.titleSlip;
    return I.titleRestock;
  }
  function ctxOf(btn) {
    return {
      productId: btn.getAttribute('data-kr-product') || '',
      variantId: btn.getAttribute('data-kr-variant') || '',
      handle: btn.getAttribute('data-kr-handle') || '',
      kind: btn.getAttribute('data-kr-kind') || 'restock',
      title: btn.getAttribute('data-kr-title') || ''
    };
  }
  function numId(x) { var n = parseInt(x, 10); return isNaN(n) ? x : n; }
  // Hand a Kairii notify click off to STOQ's JS API (its app embed must be enabled).
  // Keeps our button; STOQ owns the capture modal + the email send. Returns true if handled.
  function stoqOpen(ctx) {
    var R = window._RestockRocket;
    if (!R || typeof R.openModal !== 'function') return false;
    var productData = {
      id: numId(ctx.productId),
      title: ctx.title,
      handle: ctx.handle,
      variants: [{ id: numId(ctx.variantId), available: false }]
    };
    var customerData = EMAIL ? { email: EMAIL } : undefined;
    try { R.openModal(productData, String(ctx.variantId), customerData); return true; }
    catch (e) { return false; }
  }

  // Mark a button as subscribed (works with or without a backend).
  function markOn(btn) {
    btn.classList.add('is-on');
    btn.setAttribute('aria-disabled', 'true');
    if (btn.classList.contains('kr-po-notify--ghost')) return;        // slip ghost: visual only
    var span = btn.querySelector('span');
    if (span) { span.textContent = I.onList || span.textContent; return; }
    if (btn.classList.contains('kr-po-notify')) { btn.lastChild.textContent = ' ' + (I.onList || ''); return; }
    btn.textContent = I.onList || btn.textContent;                    // text-only card button
  }

  /* ---- Notify backend adapter ----
     The Kairii UI (button → modal → email capture) is backend-agnostic; this is the ONLY spot that
     talks to whatever actually sends the email. Klaviyo was removed. Until a backend is wired, there
     is no live send: with no key set, the click handler short-circuits to the visual-only "on the
     list" state and this is never called. To go live, replace subscribe() with the chosen app's call
     (its JS API / form endpoint) — ctx = { email, productId, variantId, kind, title }. */
  var krNotifyAdapter = window.krNotifyAdapter || {
    subscribe: function (ctx) {
      return Promise.reject(new Error('notify-backend-not-configured'));
    }
  };
  window.krNotifyAdapter = krNotifyAdapter;

  function subscribe(ctx) { return krNotifyAdapter.subscribe(ctx); }

  function openModal(btn, ctx) {
    if (!modal) { markOn(btn); return; }
    pendingBtn = btn; pendingCtx = ctx;
    if (titleEl) titleEl.textContent = titleFor(ctx.kind) || '';
    if (subEl) subEl.textContent = (I.sub || '').replace('%s', ctx.title || '');
    if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; msgEl.classList.remove('is-err'); }
    if (submitEl) submitEl.removeAttribute('disabled');
    if (emailEl) emailEl.value = EMAIL || '';
    modal.hidden = false; if (scrim) scrim.hidden = false;
    document.documentElement.classList.add('kr-notify-open');
    setTimeout(function () { if (emailEl) emailEl.focus(); }, 30);
  }
  function closeModal() {
    if (modal) modal.hidden = true;
    if (scrim) scrim.hidden = true;
    document.documentElement.classList.remove('kr-notify-open');
    pendingBtn = null; pendingCtx = null;
  }
  function fail() {
    if (msgEl) { msgEl.hidden = false; msgEl.classList.add('is-err'); msgEl.textContent = I.error || 'Error'; }
    if (submitEl) submitEl.removeAttribute('disabled');
  }
  function succeed(btn) {
    if (btn) markOn(btn);
    if (msgEl) { msgEl.hidden = false; msgEl.classList.remove('is-err'); msgEl.textContent = I.success || I.onList || '✓'; }
    setTimeout(closeModal, 1400);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest && t.closest('[data-kr-notify]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      if (btn.classList.contains('is-on')) return;
      var ctx = ctxOf(btn);
      // "alert me if it slips" is a release-date-change alert — STOQ doesn't do that — keep visual-only.
      if (ctx.kind === 'preorder_slip') { markOn(btn); return; }
      // restock / pre-order availability → hand off to STOQ's capture modal (its app embed must be on).
      if (stoqOpen(ctx)) return;
      // STOQ not loaded yet (app not installed/enabled) → safe visual-only placeholder, no error.
      markOn(btn);
      return;
    }
    if (t.closest && (t.closest('[data-kr-notify-close]') || t.closest('[data-kr-notify-scrim]'))) closeModal();
  });

  if (formEl) formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (emailEl && emailEl.value || '').trim();
    if (!email || email.indexOf('@') < 1) { if (emailEl) emailEl.focus(); return; }
    if (submitEl) submitEl.setAttribute('disabled', 'disabled');
    var btn = pendingBtn, ctx = pendingCtx || {};
    subscribe(mix(email, ctx)).then(function () { succeed(btn); }).catch(fail);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  function mix(email, ctx) {
    return { email: email, productId: ctx.productId, variantId: ctx.variantId, kind: ctx.kind, title: ctx.title };
  }
})();
